<div class="calendarlist__wrapper">
  <div class="calendar-day-wrapper" *ngFor="let day of events | keyvalue">
    <app-calendar-list-day
      [events]="day.value"
      [day]="day.key"
    ></app-calendar-list-day>
  </div>
  <div *ngIf="!events || !events?.size">There are no events in this month</div>
</div>
